import script from "./ShoesType.vue?vue&type=script&setup=true&lang=js"
export * from "./ShoesType.vue?vue&type=script&setup=true&lang=js"

import "./ShoesType.vue?vue&type=style&index=0&id=762cd570&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-762cd570"]])

export default __exports__